<template>
  <template v-if="showSmall">
    <a v-if="linkCounter" :href="sanitizeUrl(articleUrl) + '#likes-and-comments'" class="comments-counter-link comments-counter-dark btn" >
      <i class="fa-regular fa-comment" aria-hidden="true"></i> <span :class="spanClass">{{commentsCount}}</span>
    </a>
    <span v-if="!linkCounter" :class="spanClass" class="comments-counter-dark"><i class="fa-regular fa-comment" aria-hidden="true"></i> {{commentsCount}} </span>
  </template>
  <template v-else>
    <span :class="spanClass" class="comments-counter-dark">{{commentsCount}} {{commentsString}}</span>
  </template>
</template>
<script lang="ts">

import commentService from '@/services/commentService';
import { defineComponent } from 'vue'
import { sanitizeUrl } from '@braintree/sanitize-url'

export default defineComponent({
  name: 'Likes',
  props: {
    articleUuid: String,
    useBoldFont: Boolean,
    articleUrl: {
      type: String,
      required: false
    },
    showSmall: Boolean
  },
  data() {
    return {
      cmsArticleUUID: '',
      commentsCount: 0,
      sanitizeUrl: sanitizeUrl
    };
  },
  mounted() {
    if (this.articleUuid !== undefined) {
      this.cmsArticleUUID = this.articleUuid
    }
    this.loadCommentsCount()
  },
  computed: {
    commentsString() {
      if (this.commentsCount === 1) {
        return 'Kommentar'
      } else {
        return 'Kommentare'
      }
    },
    spanClass() {
      if(this.useBoldFont !== undefined && this.useBoldFont) {
        return 'fw-bold'
      }
      return ''
    },
    linkCounter(): boolean {
      return this.articleUrl !== undefined && this.articleUrl.length > 0
    }
  },

  methods: {
    loadCommentsCount(): Promise<number> {
      return commentService.getComments(this.cmsArticleUUID, false).then(commentThread => {
        this.commentsCount = 0
        if (commentThread.comments !== undefined && commentThread.comments.length > 0) {
          commentThread.comments.forEach((elem) => {
            if (elem.deleted !== true) {
              this.commentsCount++
            }
            elem.replies?.forEach(reply => {
              if (reply.deleted !== true) {
              this.commentsCount++
            }
            })
          })
        }
        return this.commentsCount

      })
    }
  }
});
</script>
